export const fieldsInformation = {
  address: 'CharacteristicsModule',
  addressType: 'CharacteristicsModule',
  bic: 'BillingPaymentModule',
  city: 'CharacteristicsModule',
  cityId: 'CharacteristicsModule',
  civility2: 'CustomerModule',
  civility: 'CustomerModule',
  dataCollectionAuth: 'CustomerModule',
  email: 'CustomerModule',
  productType: 'CharacteristicsModule',
  iban: 'BillingPaymentModule',
  name2: 'CustomerModule',
  name: 'CustomerModule',
  firstname: 'CustomerModule',
  offer_id: 'OfferModule',
  offerId: 'OfferModule',
  pdlNo: 'PDLModule',
  phone1: 'CustomerModule',
  phone2: 'CustomerModule',
  neverbounce_result: 'CustomerModule',
  prestationType: 'CharacteristicsModule',
  providerId: 'OfferModule',
  provider_external_id: 'OfferModule',
  socialReason: 'CustomerModule',
  streetNumber: 'CharacteristicsModule',
  surname2: 'CustomerModule',
  surname: 'CustomerModule',
  lastname: 'CustomerModule',
  zipcode: 'CharacteristicsModule',
  zohoId: 'ZohoModule',
  zoho_id: 'ZohoModule',
  meter_id_elec: 'PDLModule',
  meter_id_elec_duplicated: 'PDLModule',
  meter_id_gas_duplicated: 'PCEModule',
  meter_id_gas: 'PCEModule',
  comments: 'ConsumptionModule',
  city_id: 'CharacteristicsModule',
  imei: 'AdditionalInformationModule',
  accountHolderFirstname: 'BillingPaymentModule',
  accountHolderLastname: 'BillingPaymentModule',
  accountHolderTaxIdCode: 'BillingPaymentModule',
  providersBlacklist: 'BillingPaymentModule',
  activity: 'CustomerModule',
  additionalInformation: 'AddressModule',
  apeCode: 'CustomerModule',
  appartmentNumber: 'AddressModule',
  billAmountElec: 'PDLModule',
  billAmountGas: 'PCEModule',
  billingFrequency: 'BillingPaymentModule',
  birthdate: 'CustomerModule',
  birthday: 'CustomerModule',
  bottleNumber: 'PropaneModule',
  bottleSize: 'PropaneModule',
  bypass_retractation_elec: 'EffectiveDateModule',
  car: 'PropaneModule',
  car_elec_base: 'ConsumptionModule',
  car_elec_base_original: 'ConsumptionModule',
  car_elec_hc: 'ConsumptionModule',
  car_elec_hc_original: 'ConsumptionModule',
  car_elec_hp_original: 'ConsumptionModule',
  carHc: 'ConsumptionModule',
  car_elec_hp: 'ConsumptionModule',
  carHp: 'ConsumptionModule',
  car_gas: 'ConsumptionModule',
  car_gas_original: 'ConsumptionModule',
  carBase: 'ConsumptionModule',
  carGas: 'ConsumptionModule',
  contact_time_propane: 'PropaneModule',
  contactTime: 'PropaneModule',
  contractType: 'CharacteristicsModule',
  cooking: 'ConsumptionModule',
  country: 'AddressModule',
  current_use_propane: 'PropaneModule',
  currentUse: 'PropaneModule',
  debordement: 'OfferModule',
  disclaimerCommitmentPro: 'CharacteristicsModule',
  disclaimerCommitmentProOui: 'CharacteristicsModule',
  effective_date_elec: 'EffectiveDateModule',
  elecEffectiveDate: 'EffectiveDateModule',
  elecIndex: 'PDLModule',
  elecMeterType: 'PDLModule',
  elecReadingDate: 'PDLModule',
  energyOriginElec: 'OfferModule',
  energyOriginGas: 'OfferModule',
  energySupplierElec: 'PDLModule',
  energySupplierGas: 'PCEModule',
  originMarketGas: 'PCEModule',
  originMarketElec: 'PDLModule',
  energySupplierPropane: 'PropaneModule',
  energyType: 'CharacteristicsModule',
  energy_type: 'CharacteristicsModule',
  floor: 'AddressModule',
  gasEffectiveDate: 'EffectiveDateModule',
  gasIndex: 'PCEModule',
  gasMeterType: 'PCEModule',
  gasReadingDate: 'PCEModule',
  heating: 'ConsumptionModule',
  hotwater: 'ConsumptionModule',
  household: 'ConsumptionModule',
  housingType: 'AddressModule',
  installation_age_propane: 'PropaneModule',
  tankType: 'PropaneModule',
  invoice_sending_mode: 'BillingPaymentModule',
  invoiceSendingMode: 'BillingPaymentModule',
  invoiceStreetName: 'BillingPaymentModule',
  meter_option_elec: 'PDLModule',
  meter_power_elec: 'PDLModule',
  meterPower: 'PDLModule',
  modificationReason: 'ConsumptionModule',
  monthly_amount: 'ConsumptionModule',
  monthlyAmount: 'ConsumptionModule',
  movingStartDate: 'AddressModule',
  occupancy: 'ConsumptionModule',
  paymentDate: 'BillingPaymentModule',
  paymentMode: 'BillingPaymentModule',
  pceNo: 'PCEModule',
  presence: 'PropaneModule',
  presence_propane: 'PropaneModule',
  bottle_size_propane: 'PropaneModule',
  bottle_number_propane: 'PropaneModule',
  project_deadline_propane: 'PropaneModule',
  quoteReason: 'PropaneModule',
  reading_date_elec: 'PDLModule',
  realPayment: 'BillingPaymentModule',
  residenceType: 'AddressModule',
  siret: 'CustomerModule',
  pro_siret: 'CustomerModule',
  surface: 'ConsumptionModule',
  tank_access_propane: 'PropaneModule',
  tankAccess: 'PropaneModule',
  tariffOption: 'PDLModule',
  tenantType: 'AddressModule',
  cooking_energy: 'ConsumptionModule',
  heating_energy: 'ConsumptionModule',
  hotwater_energy: 'ConsumptionModule',
  number_of_occupants: 'ConsumptionModule',
  conso_residence_type: 'ConsumptionModule',
  residence_presence_main: 'ConsumptionModule',
  saleIdMandatory: 'OfferModule',
  product_type: 'CharacteristicsModule',
  commitmentEndDate: 'OfferModule',
  annual_premium: 'OfferModule',
  annual_commission: 'OfferModule',
  taxIdCode: 'CustomerModule',
  consumptionBase: 'ConsumptionModule',
  consumptionBiorariaF1: 'ConsumptionModule',
  consumptionBiorariaF2: 'ConsumptionModule',
  consumptionBiorariaF3: 'ConsumptionModule',
  electricityDistributor: 'PDLModule',
  gasDistributor: 'PCEModule',
  doiPhone: 'OfferModule',
  doiPrivacy: 'OfferModule',
  distributorCode: 'PCEModule',
  daysOfUse: 'PCEModule',
  identityDocumentNumber: 'IdentityModule',
  identityExpirationDate: 'IdentityModule',
  identityCreatedDate: 'IdentityModule',
  identityIssuingEntity: 'IdentityModule',
  identityIssuingCity: 'IdentityModule',
  delegateSurname: 'IdentityModule',
  delegateName: 'DelegateModule',
  delegateCf: 'DelegateModule',
  delegateDocumentNumber: 'DelegateModule',
  delegateExpirationDate: 'DelegateModule',
  cadastralSheetNumber: 'AddressModule',
  cadastralParcelNumber: 'AddressModule',
  cadastralSubunitNumber: 'AddressModule',
  lastHolderName: 'AddressModule',
  lastHolderCf: 'AddressModule',
  lastHolderPropertyDate: 'AddressModule',
  bornCity: 'CustomerModule',
  buildingPermitOption: 'AddressModule',
  buildingPermitNumber: 'AddressModule',
  buildingPermitDate: 'AddressModule',
  buildingPermitEntity: 'AddressModule',
  buildingPermitCity: 'AddressModule',
}
